import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import {AuthService} from '../../core/security/auth.service';
import {DownloadsService} from '../downloads.service';
import {Subscription} from 'rxjs';
import {NotificationModel} from '../../api/models/notification-model';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import {NotificationService} from '../../notification/notification.service';
import { MatCard, MatCardTitle, MatCardContent } from '@angular/material/card';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-downloads-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    standalone: true,
    imports: [
        MatCard,
        MatCardTitle,
        MatCardContent,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        DatePipe,
    ],
})
export class ListComponent extends BaseComponent implements OnInit, OnDestroy {

  isLoading = false;
  displayedColumns: string[] = ['time', 'url'];
  dataSource = new MatTableDataSource<NotificationModel>([]);


  private paramsSubscription: Subscription;

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title,
              public authService: AuthService,
              public httpService: HttpClient,
              public downloadsService: DownloadsService,
              public notificationService: NotificationService
  ) {
    super(route, headerService, titleService, authService);

    this.paramsSubscription = this.route.queryParams.subscribe(async (params) => {
      const download = params['d'];
      if (download) {
        const downloadUrl = atob(download);
        await this.downloadFile(downloadUrl);
      }
    });
  }

  async downloadFile(url: string): Promise<void>{

    try {
      const response = await this.httpService.get<any>(url,{responseType: 'blob' as 'json'}).toPromise();
      let dataType = response.type;
      let binaryData = [];
      binaryData.push(response);
      let downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
      //if (filename)
      //  downloadLink.setAttribute('download', filename);
      document.body.appendChild(downloadLink);
      downloadLink.click();
    }
    catch(e) {
      console.error('error downloading file', e);
      this.notificationService.notifyDanger(`This file has expired. Please redo the export.`);
    }
  }

  ngOnInit() {
    console.log('on init');
    super.ngOnInit();

    this.downloadsService.getExportFileList()
      .then((list) => {
        this.dataSource.data = list.filter(x => x.url.startsWith('#'));
      });
  }

  ngOnDestroy() {
    this.paramsSubscription?.unsubscribe();

    super.ngOnDestroy();
  }

}
